import React from 'react';

// Bronson pagination links render `href="#"`; without this the browser navigates to "#",
// which re-mounts the postbox and resets the selected page and filters.
export const preventDefault = (handler: () => void) => (event: React.MouseEvent): void => {
    event.preventDefault();
    handler();
};
